import React from "react";
import { Filter, useTranslate } from "react-admin";
import { SearchInput } from "../../component/input";

const ProductFilter = props => {
    const translate = useTranslate();

    return (
        <Filter {...props}>
            <SearchInput
                alwaysOn
                label={translate("product.label.ref")}
                source="ref.lk"
            />
        </Filter>
    );
};

export default ProductFilter;
